module.exports = __webpack_public_path__ + "img/box.3dc32137.svg";